import './style.css';

export function iconify(icon = 'ok') {
    let div = document.createElement('div');

    div.setAttribute('data-role', 'iconify');

    if (icon == 'ok') {
        div.html('<img src="./images/ok.png" alt="ok" />');
    }

    document.body.append(div);

    let keyframes = [
        {"transform": 'translateY(150%)',"opacity":"0"},
        {"transform": 'translateY(0)', "opacity":"1"}
    ]

    div.custom_animate(keyframes, 400, () => {
        setTimeout(() => {
            div.fadeOut(600, () => {
                div.remove();
            })
        }, 2000)
    })
}
